import { useUniSelectorContext } from '@src/contexts/uni-selector/useUniSelectorContext';

export const useQueryKeys = (keys: unknown[]) => {
  const filteredKeys = keys.filter((key) => key !== undefined);
  const { selectedUniversityId } = useUniSelectorContext();
  if (!selectedUniversityId) {
    return filteredKeys;
  }
  return [selectedUniversityId, ...filteredKeys];
};
